<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    //this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.patients.totalItems / this.filters.pageSize
      );
    },
    patients() {
      return this.$store.state.patients.patients;
    },

  },

  data() {
    return {
      view: 0,

      filters: {
        page: 1,
        pageSize: 10,

        name: null,
        status: null,
      },
      headers: [
        { text: 'الاسم الاول', value: 'firstName' },
        { text: 'اللقب', value: 'lastName' },
        { text: 'رقم الهاتف', value: 'phone' },
        { text: 'البريد الكتروني', value: 'email' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      list: [
        { label: "1", value: 1 }
      ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("patients/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },   
     editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`patients/delete`, this.itemId);
    },
    back(){
      this.view = 0;
    }
  },
};
</script>

<style scoped>
</style>